import {
  Component,
  EventEmitter,
  Input,
  Output,
  HostListener,
  OnInit,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PanAppState } from '@panamax/app-state';
import { ProductDetailViewModel } from '@product-detail/models/product-detail-view-model';
import { getAlternativeThumbnail } from '@product-detail/utils/product-images.util';
import { ProductState } from '@usf/ngrx-product';

@Component({
  selector: 'app-product-comparison-popover',
  templateUrl: './product-comparison-popover.component.html',
  styleUrls: ['./product-comparison-popover.component.scss'],
})
export class ProductComparisonPopoverComponent implements OnInit {
  @Input() productDetails: ProductDetailViewModel;
  @Input() isActionable = false;
  @Input() isGuestUser = false;
  @Input() cardsNumber: number;
  @Input() productIndex: number;
  @Output() closeCardEmitter = new EventEmitter<ProductDetailViewModel>();
  hasCustomMessage: boolean;
  messageMainText: string;
  messageSecondaryText: string;
  customMessageIsWarning: boolean;

  constructor(
    readonly panAppState: PanAppState,
    private translateService: TranslateService,
  ) {}

  getAlternativeThumbnail = (thumbnailImageURL: string): string => {
    return getAlternativeThumbnail(
      this.productDetails?.summary as ProductState,
      thumbnailImageURL,
    );
  };

  getPopoverMessage() {
    const mainText =
      this.productDetails?.drawerMsg?.isWarning ||
      this.productDetails?.productCardWarningMsg?.display
        ? this.productDetails?.productCardWarningMsg?.primaryText
        : this.productDetails?.drawerMsg?.message;
    const secondaryText = this.productDetails?.productCardWarningMsg
      ?.secondaryText
      ? this.translateService.instant(
          this.productDetails?.productCardWarningMsg?.secondaryText,
        )
      : '';

    const textDate = this.productDetails?.productCardWarningMsg
      ?.secondaryTextDate
      ? this.productDetails?.productCardWarningMsg?.secondaryTextDate
      : '';

    this.messageMainText = mainText;
    this.messageSecondaryText = ' ' + secondaryText + ' ' + textDate;

    this.hasCustomMessage =
      !!this.productDetails?.drawerMsg?.message ||
      !!this.productDetails?.productCardWarningMsg?.primaryText;

    this.customMessageIsWarning =
      (!!this.productDetails?.drawerMsg?.message &&
        this.productDetails?.drawerMsg?.isWarning) ||
      this.productDetails?.productCardWarningMsg?.display;
  }

  closeCardHandler(productDetails: ProductDetailViewModel) {
    this.closeCardEmitter.emit(productDetails);
  }

  ngOnInit(): void {
    this.getPopoverMessage();
  }

  get productPopoverClass() {
    const secondElement = this.productIndex !== 0 ? 'border' : 'first';
    const thirdElement =
      this.productIndex === this.cardsNumber - 1 ? 'last' : '';

    if (this.isGuestUser) {
      return ['has-normal-drawer', secondElement, thirdElement];
    }

    return [
      !!this.productDetails?.drawerMsg?.message ||
      !!this.productDetails?.productCardWarningMsg?.primaryText
        ? !this.productDetails?.drawerMsg?.isWarning &&
          !this.productDetails?.productCardWarningMsg?.display
          ? 'has-normal-drawer'
          : 'has-warning-drawer'
        : 'no-message',
      secondElement,
      thirdElement,
    ];
  }
}
